import { useState, useEffect } from 'react';
import { siteInfo } from '@/mocks/homeData';

const navItems = [
  { name: '首页', href: '#hero' },
  { name: '平台介绍', href: '#about' },
  { name: '焦点专题', href: '#carousel' },
  { name: '常见问答', href: '#faq' },
  { name: 'APP下载', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between h-[72px] px-4 md:px-8 max-w-[1400px]">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 text-foreground-950 no-underline"
        >
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-movie-2-fill text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-heading font-bold tracking-wide whitespace-nowrap">{siteInfo.name}</span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
            >
              {item.name}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#app"
            onClick={(e) => handleNavClick(e, '#app')}
            className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
          >
            下载APP
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {item.name}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => handleNavClick(e, '#app')}
              className="mt-2 px-4 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer no-underline"
            >
              下载APP
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}